import { allEventsInSeries } from 'owa-locstrings/lib/strings/alleventsinseries.locstring.json';
import { thisEvent } from 'owa-locstrings/lib/strings/thisevent.locstring.json';
import loc from 'owa-localize';

import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { addCalendarEventToMyCalendar } from 'owa-calendar-events-actions';
import { ViewType } from 'owa-calendar-actions';
import { ClientItemId } from 'owa-client-ids';

export default function getAddEventToMyCalendarMenuItems(
    item: {
        IsRecurring: boolean;
        ItemId: ClientItemId;
    },
    actionSource: ViewType
): IContextualMenuItem[] {
    return item.IsRecurring
        ? [
              {
                  key: 'addToMyCalendar_occurrence',
                  name: loc(thisEvent),
                  onClick: () => {
                      addCalendarEventToMyCalendar(
                          item.ItemId,
                          actionSource,
                          false /* addSeries */
                      );
                  },
              },
              {
                  key: 'addToMyCalendar_series',
                  name: loc(allEventsInSeries),
                  onClick: () => {
                      addCalendarEventToMyCalendar(item.ItemId, actionSource, true /* addSeries */);
                  },
              },
          ]
        : [];
}
